import dataProvider from "src/dataProvider";

const fetcher = dataProvider("adminInstance");

export interface AdminQueryMessage {
  id: string;
  senderId: string;
  receiverId: string;
  message: string;
  isRead: boolean;
  createdAt: string;
  sender?: {
    id: string;
    firstName?: string;
    lastName?: string;
    email?: string;
  };
  receiver?: {
    id: string;
    firstName?: string;
    lastName?: string;
    email?: string;
  };
}

export const sendAdminQuery = async (payload: {
  receiverId: string;
  message: string;
}) => {
  return fetcher.post<typeof payload, { success: boolean; data: AdminQueryMessage }>(
    "/admin-query/admin/send",
    payload,
  );
};

export const getAdminQueriesByGcaUser = async (gcaUserId: string) => {
  return fetcher.get<{ success: boolean; data: AdminQueryMessage[] }>(
    `/admin-query/by-gca-user/${gcaUserId}`,
  );
};

export const getAdminQueryUnread = async (fromUserId?: string) => {
  return fetcher.get<{ success: boolean; data: { count: number } }>(
    "/admin-query/unread",
    fromUserId ? { fromUserId } : {},
  );
};
